<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M22 8.91V3a1 1 0 00-1-1h-5.91a1.05 1.05 0 00-.71.29L2.29 14.38a1 1 0 000 1.42l5.91 5.91a1 1 0 00.71.29 1 1 0 00.71-.29l1.78-1.79a.47.47 0 00.06-.09A6 6 0 0015 21a6 6 0 003.47-1.11l1.82 1.82a1 1 0 001.42 0 1 1 0 000-1.42l-1.82-1.82A6 6 0 0021 15a6 6 0 00-1.11-3.47l1.84-1.93a1 1 0 00.27-.69zM15 19a4 4 0 114-4 4 4 0 01-4 4zm5-10.49l-1.52 1.61a6 6 0 00-8.39 8.32l-.1.07-1.08 1.08-4.5-4.5L15.51 4H20z"/><circle cx="17.5" cy="6.5" r="1"/></svg>